import http from "./http";

export default () => ({
  async index(filters) {
    return http
      .index("product_price_change", filters)
      .then((json) => ({ productPriceChanges: json }))
      .catch(async (e) => ({ productPriceChanges: null, error: await e }));
  },
  async create(data) {
    return http
      .post("product_price_change", data)
      .then((json) => ({ productPriceChange: json }))
      .catch(async (e) => ({ productPriceChange: null, error: await e }));
  },
});
